import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" id=\"icon-download\">\r\n<g>\r\n\t<path d=\"M13.133,9.411v3.716H1.867V9.414H0V15h15V9.411H13.133z M11.277,5.599H9.378V0H5.611v5.609H3.739\r\n\t\tc1.276,1.916,2.511,3.77,3.767,5.654C8.768,9.367,10,7.517,11.277,5.599z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/download.svg
// module id = ./app/general/svg/download.svg
// module chunks = app